<div class="staticPage editor-page" style="text-align: justify;">
  <div class="p-grid">
    <div class="p-col-12">
      <h1 class="blueColor" style="text-align: center;">{{ 'terms_and_conds' | translate }}</h1>
      <div class="gradientDivider"></div>
      <div class="content-from-editor" [innerHTML]="regulationsHtml"></div>
    </div>
  </div>
</div>
